import { Button } from "@/components/ui/button";
import { PhoneCall, CalendarCheck } from "lucide-react";
import { usePhoneBar } from "@/contexts/PhoneBarContext";

export const AdsBottomCTA = () => {
  const { phoneNumber } = usePhoneBar();
  const formattedPhone = phoneNumber.replace("+1", "").replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");

  return (
    <section className="py-16 bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 text-center">
        <CalendarCheck className="w-12 h-12 mx-auto mb-4 opacity-80" />
        <h2 className="text-3xl md:text-4xl font-extrabold mb-3">
          Ready to Protect Your Home?
        </h2>
        <p className="text-lg opacity-90 mb-8 max-w-lg mx-auto">
          Don't wait until it's too late. Schedule your free inspection today and get $500 off your roof replacement.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            variant="secondary"
            className="font-bold text-base px-8"
            onClick={() => (window.location.href = `tel:${phoneNumber}`)}
          >
            <PhoneCall className="w-5 h-5 mr-2" />
            Call {formattedPhone}
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="font-bold text-base px-8 bg-transparent border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Get Free Estimate
          </Button>
        </div>
      </div>
    </section>
  );
};
